import type { ButtonHTMLAttributes } from "react";
import type { VariantProps } from "class-variance-authority";

import { Button, type buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type GradientButtonProps = {
  children: React.ReactNode;
  className?: string;
  disableAmination?: boolean;
  variant?: VariantProps<typeof buttonVariants>["variant"];
} & ButtonHTMLAttributes<HTMLButtonElement>;

const GradientButton = ({
  children,
  className,
  disableAmination = false,
  variant,
  ...props
}: GradientButtonProps) => {
  const gradientStyle = {
    backgroundImage: "linear-gradient(to right, #ffaa40, #9c40ff, #ffaa40)",
    backgroundSize: "300% 100%",
    animationDuration: "3s",
  };

  const isGradient = variant !== "outline";

  return (
    <Button
      variant={variant}
      className={cn(
        isGradient &&
          "relative h-8 animate-gradient overflow-hidden border-none font-bold text-white transition-shadow hover:shadow-lg",
        className,
      )}
      style={disableAmination || !isGradient ? {} : gradientStyle}
      {...props}
    >
      {children}
    </Button>
  );
};

export default GradientButton;
